import createTradePlanCopy from '../../../../../../../../classes/tradePlan/createTradePlanCopy';
import { addTradePlan } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/addtradeplanmessage/addTradePlan';
import { submitTradePlan } from './submitTradePlan';
import {GetErrorMessage} from "./breakBounceErrorMessages";

export function addBreakSetup({
  contextMenuProps,
  currentPrice,
  tradePlanForm,
  autoSend,
  scaleY,
  websocketStore,
}) {
  // TODO consolidate addBounce, addBreak, et al
  // TODO hold an array of setups somewhere to allow for multiple, coordinated Trade Plans

  const setup = 'BREAK';
  // TODO make sure new BREAK is consistent with direction
  const direction = tradePlanForm?.direction ?? null;

  if (currentPrice === null) {
    tradePlanForm.setValidationStatus({
      status: false,
      message: 'Issue obtaining current price with selected data source.',
    });
    return;
  }

  const priceOfSetup = scaleY.invert(contextMenuProps.yCoordinate);
  const instrument = tradePlanForm.instrument;

  // TODO DRY -- similar logic found in submitTradePlan
  const isLongSetupValid = priceOfSetup >= 0.0 && ((setup === 'BREAK' && Number(currentPrice) < priceOfSetup && tradePlanForm.direction !== 'SHORT')/* ||
    (setup === 'BOUNCE' && Number(currentPrice) > priceOfSetup && tradePlanForm.direction !== 'SHORT')*/);
  const isShortSetupValid = priceOfSetup >= 0.0 && ((setup === 'BREAK' && Number(currentPrice) > priceOfSetup && tradePlanForm.direction !== 'LONG')/* ||
    (setup === 'BOUNCE' && Number(currentPrice) < priceOfSetup && tradePlanForm.direction !== 'LONG')*/);

  if (isLongSetupValid) {
    tradePlanForm.setSetup('BREAK', { priceToBreak: priceOfSetup });
  }

  if( isShortSetupValid ) {
    tradePlanForm.setSetup('BREAK', { priceToBreak: priceOfSetup });
  }

  if( !isLongSetupValid && !isShortSetupValid ) {
    const err = GetErrorMessage({direction, setup, currentPrice, price: priceOfSetup})
    tradePlanForm.setValidationStatus(err);
    return
  }

  if (autoSend) {
    let om = null;
    if( instrument === 'option' )
      om = tradePlanForm.optionManagement.returnJson();

    // make sure direction suits the setup
    const overrides = { goLong: isLongSetupValid, goShort: isShortSetupValid, optionManagement: om }
    submitTradePlan({ currentPrice, tradePlanForm, overrides, websocketStore });
  }
}
